/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1PersonIdContactDataMutationRequest,
  PutApiV1PersonIdContactDataMutationResponse,
  PutApiV1PersonIdContactDataPathParams,
  PutApiV1PersonIdContactData400,
  PutApiV1PersonIdContactData401,
  PutApiV1PersonIdContactData404,
  PutApiV1PersonIdContactData500,
} from "../../types/personRegisterController/PutApiV1PersonIdContactData.ts";

function getPutApiV1PersonIdContactDataUrl(
  id: PutApiV1PersonIdContactDataPathParams["id"],
) {
  const res = {
    method: "PUT",
    url: `/api/v1/person/${id}/contact-data` as const,
  };
  return res;
}

/**
 * @description Atualiza parcialmente os dados de contato de uma pessoa. **(Requer Authorization para autenticação)**
 * @summary Atualizar dados de contato (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/contact-data}
 */
export async function putApiV1PersonIdContactData(
  id: PutApiV1PersonIdContactDataPathParams["id"],
  data?: PutApiV1PersonIdContactDataMutationRequest,
  config: Partial<RequestConfig<PutApiV1PersonIdContactDataMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1PersonIdContactDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdContactData400
      | PutApiV1PersonIdContactData401
      | PutApiV1PersonIdContactData404
      | PutApiV1PersonIdContactData500
    >,
    PutApiV1PersonIdContactDataMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1PersonIdContactDataUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
